export default {
  "keyDriversVisual": {
    "config": {
      "changed": false,
      "title": "Key influencers",
      "navSection": "qa",
      "icon": "keyDriversVisual",
      "image": "keyInfluencers.png"
    },
    "items": {
      "keyDrivers": {
        "allowKeyDrivers": true,
        "allowProfiles": true,
        "selectedNumericAnalysis": "Continuous",
        "allowKeyDriversCounting": false,
        "countType": "absolute"
      },
      "keyInfluencersVisual": {
        "primaryColor": "#118DFF",
        "primaryFontColor": "#EAEAEA",
        "secondaryColor": "#C8C8C8",
        "secondaryFontColor": "#ffffff",
        "canvasColor": "#F4F4F4",
        "fontColor": "#252423"
      },
      "keyDriversDrillVisual": {
        "defaultColor": "#12239E",
        "referenceLineColor": "#E66C37"
      },
      "title": {
        "show": false,
        "text": "",
        "titleWrap": true,
        "fontColor": "#252423",
        "background": "#FFFFFF",
        "alignment": "left",
        "fontSize": 14,
        "fontFamily": "Segoe UI"
      },
      "background": {
        "show": true,
        "color": "#252423",
        "transparency": 0
      },
      "lockAspect": {
        "show": false
      },
      "border": {
        "show": false,
        "color": "#252423",
        "radius": 0
      },
      "dropShadow": {
        "show": false,
        "color": "#252423",
        "position": "Outer",
        "preset": "BottomRight",
        "shadowSpread": 3,
        "shadowBlur": 10,
        "angle": 45,
        "shadowDistance": 10,
        "transparency": 70
      },
      "visualTooltip": {
        "show": false,
        "type": "Report page",
        "titleFontColor": "#252423",
        "valueFontColor": "#252423",
        "actionFontColor": "#252423",
        "fontSize": 12,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5,
        "page": "Auto"
      },
      "visualHeader": {
        "show": true,
        "background": "#ffffff",
        "border": "#ffffff",
        "transparency": 0,
        "foreground": "#333",
        "showVisualInformationButton": true,
        "showVisualWarningButton": true,
        "showVisualErrorButton": true,
        "showDrillRoleSelector": true,
        "showDrillUpButton": true,
        "showDrillToggleButton": true,
        "showDrillDownLevelButton": true,
        "showDrillDownExpandButton": true,
        "showPinButton": true,
        "showFocusModeButton": true,
        "showFilterRestatementButton": true,
        "showSeeDataLayoutToggleButton": true,
        "showOptionsMenu": true,
        "showTooltipButton": false
      },
      "visualHeaderTooltip": {
        "text": "",
        "titleFontColor": "#C8C8C8",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      }
    }
  },
  "decompositionTreeVisual": {
    "config": {
      "changed": false,
      "title": "Decomposition tree",
      "navSection": "qa",
      "icon": "decompositionTreeVisual",
      "image": "decompositionTreeVisual.png"
    },
    "items": {
      "analysis": {
        "aiEnabled": true,
        "aiMode": "relative"
      },
      "tree": {
        "accentColor": "#ABCDEF",
        "barsPerLevel": 20,
        "connectorDefaultColor": "#0100AA",
        "connectorType": "round",
        "density": "sparse"
      },
      "dataBars": {
        "dataBarBackgroundColor": "#AFB5B6",
        "dataBarScalingType": "parentNode",
        "dataBarWidthPercent": 100,
        "negativeBarColor": "#FF0F12",
        "positiveBarColor": "#00FF2E"
      },
      "categoryLabels": {
        "categoryLabelFontColor": "#0100AA",
        "categoryLabelFontFamily": "Verdana",
        "categoryLabelFontSize": 13
      },
      "dataLabels": {
        "dataLabelDisplayUnits": "0",
        "dataLabelFontColor": "#0100AA",
        "dataLabelFontFamily": "Verdana",
        "dataLabelFontSize": 15
      },
      "levelHeader": {
        "levelHeaderBackgroundColor": "#252423",
        "levelSubtitleFontColor": "#FFFFFF",
        "levelSubtitleFontFamily": "Arial",
        "levelSubtitleFontSize": 18,
        "levelTitleFontColor": "#ABCDEF",
        "levelTitleFontFamily": "ArialBlack",
        "levelTitleFontSize": 20
      },
      "title": {
        "show": true,
        "text": "",
        "titleWrap": false,
        "fontColor": "#252423",
        "background": "#FFFFFF",
        "alignment": "left",
        "fontFamily": "Segoe UI",
        "fontSize": 10
      },
      "background": {
        "show": true,
        "color": "#252423",
        "transparency": 20
      },
      "lockAspect": {
        "show": true
      },
      "border": {
        "show": true,
        "color": "#252423",
        "radius": 20
      },
      "dropShadow": {
        "show": true,
        "color": "#252423",
        "position": "Outer",
        "preset": "TopRight",
        "shadowSpread": 3,
        "shadowBlur": 10,
        "angle": 45,
        "shadowDistance": 10,
        "transparency": 70
      },
      "visualTooltip": {
        "show": false,
        "titleFontColor": "#252423",
        "valueFontColor": "#252423",
        "actionFontColor": "#252423",
        "fontSize": 12,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      },
      "visualHeader": {
        "show": true,
        "background": "#ffffff",
        "border": "#9b8080",
        "transparency": 2,
        "foreground": "#4d4d4d",
        "showVisualInformationButton": true,
        "showVisualWarningButton": true,
        "showVisualErrorButton": true,
        "showDrillRoleSelector": true,
        "showDrillUpButton": true,
        "showDrillToggleButton": true,
        "showDrillDownLevelButton": true,
        "showDrillDownExpandButton": true,
        "showPinButton": true,
        "showFocusModeButton": true,
        "showFilterRestatementButton": true,
        "showSeeDataLayoutToggleButton": true,
        "showOptionsMenu": true,
        "showTooltipButton": false
      },
      "visualHeaderTooltip": {
        "text": "",
        "titleFontColor": "#C8C8C8",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      }
    }
  },
  "qnaVisual": {
    "config": {
      "changed": false,
      "title": "Q&A",
      "navSection": "qa",
      "icon": "qnaVisual",
      "image": "qnA.png"
    },
    "items": {
      "inputBox": {
        "background": "#FFFFFF",
        "questionFontColor": "#252423",
        "questionFontSize": 10,
        "questionFontFamily": "Segoe UI",
        "acceptedColor": "#0078D4",
        "errorColor": "#FF0000",
        "warningColor": "#ED7100",
        "hoverColor": "#C8C6C4",
        "restatementFontColor": "#252423",
        "restatementFontSize": 9,
        "restatementFontFamily": "Segoe UI"
      },
      "suggestions": {
        "show": true,
        "headerFontColor": "#938e89",
        "headerFontSize": 12,
        "headerFontFamily": "Segoe UI",
        "cardBackground": "#118DFF",
        "cardFontColor": "#FFFFFF",
        "cardFontSize": 10,
        "cardFontFamily": "Segoe UI"
      },
      "title": {
        "show": true,
        "text": "",
        "titleWrap": true,
        "fontColor": "#252423",
        "background": "#FFFFFF",
        "alignment": "left",
        "fontSize": 14,
        "fontFamily": "Segoe UI"
      },
      "background": {
        "show": true,
        "color": "#252423",
        "transparency": 0
      },
      "lockAspect": {
        "show": false
      },
      "border": {
        "show": false,
        "color": "#252423",
        "radius": 0
      },
      "dropShadow": {
        "show": false,
        "color": "#252423",
        "position": "Outer",
        "preset": "BottomRight",
        "shadowSpread": 3,
        "shadowBlur": 10,
        "angle": 45,
        "shadowDistance": 10,
        "transparency": 70
      },
      "visualHeader": {
        "show": true,
        "background": "#ffffff",
        "border": "#ffffff",
        "transparency": 0,
        "foreground": "#333",
        "showVisualInformationButton": true,
        "showVisualWarningButton": true,
        "showVisualErrorButton": true,
        "showDrillRoleSelector": true,
        "showDrillUpButton": true,
        "showDrillToggleButton": true,
        "showDrillDownLevelButton": true,
        "showDrillDownExpandButton": true,
        "showPinButton": true,
        "showFocusModeButton": true,
        "showFilterRestatementButton": true,
        "showSeeDataLayoutToggleButton": true,
        "showOptionsMenu": true,
        "showTooltipButton": false
      },
      "visualHeaderTooltip": {
        "text": "",
        "titleFontColor": "#C8C8C8",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      }
    }
  },
  "rdlVisual": {
    "config": {
      "changed": false,
      "title": "Paginated Report (preview)",
      "navSection": "qa",
      "icon": "rdlVisual",
      "image": "rdlVisual.png"
    },
    "items": {
      "toolbar": {
        "show": false,
        "paramButton": false
      },
      "autoFilter": {
        "show": false
      },
      "title": {
        "show": true,
        "text": "",
        "titleWrap": true,
        "fontColor": "#252423",
        "background": "#FFFFFF",
        "alignment": "left",
        "fontSize": 14,
        "fontFamily": "Segoe UI"
      },
      "background": {
        "show": true,
        "color": "#252423",
        "transparency": 0
      },
      "lockAspect": {
        "show": false
      },
      "border": {
        "show": true,
        "color": "#252423",
        "radius": 0
      },
      "dropShadow": {
        "show": false,
        "color": "#252423",
        "position": "Outer",
        "preset": "BottomRight",
        "shadowSpread": 3,
        "shadowBlur": 10,
        "angle": 45,
        "shadowDistance": 10,
        "transparency": 70
      },
      "visualTooltip": {
        "show": false,
        "type": "Report page",
        "titleFontColor": "#252423",
        "valueFontColor": "#252423",
        "actionFontColor": "#252423",
        "fontSize": 12,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5,
        "page": "Auto"
      },
      "visualHeader": {
        "show": true,
        "background": "#ffffff",
        "border": "#ffffff",
        "transparency": 0,
        "foreground": "#333",
        "showVisualInformationButton": true,
        "showVisualWarningButton": true,
        "showVisualErrorButton": true,
        "showDrillRoleSelector": true,
        "showDrillUpButton": true,
        "showDrillToggleButton": true,
        "showDrillDownLevelButton": true,
        "showDrillDownExpandButton": true,
        "showPinButton": true,
        "showFocusModeButton": true,
        "showFilterRestatementButton": true,
        "showSeeDataLayoutToggleButton": true,
        "showOptionsMenu": true,
        "showTooltipButton": false
      },
      "visualHeaderTooltip": {
        "text": "",
        "titleFontColor": "#C8C8C8",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      }
    }
  },
  "esriVisual": {
    "config": {
      "changed": false,
      "title": "ArcGIS Maps for Power BI",
      "navSection": "qa",
      "icon": "esriVisual",
      "image": "arcGISMapsforPowerBI.png"
    },
    "items": {
      "layers": {
        "layerTitle": "Layers",
        "layerVisible": true,
        "layerAnchored": false,
        "layerPosition": "left"
      },
      "mapTools": {
        "zoomTools": false,
        "basemaps": false,
        "lockMapExtent": false,
        "infographicsPosition": "right"
      },
      "locationType": {
        "country": "world"
      },
      "title": {
        "show": true,
        "text": "",
        "titleWrap": true,
        "fontColor": "#252423",
        "background": "#FFFFFF",
        "alignment": "left",
        "fontSize": 14,
        "fontFamily": "Segoe UI"
      },
      "background": {
        "show": true,
        "color": "#252423",
        "transparency": 0
      },
      "lockAspect": {
        "show": false
      },
      "border": {
        "show": true,
        "color": "#252423",
        "radius": 0
      },
      "dropShadow": {
        "show": false,
        "color": "#252423",
        "position": "Outer",
        "preset": "BottomRight",
        "shadowSpread": 3,
        "shadowBlur": 10,
        "angle": 45,
        "shadowDistance": 10,
        "transparency": 70
      },
      "visualTooltip": {
        "show": false,
        "type": "Report page",
        "titleFontColor": "#252423",
        "valueFontColor": "#252423",
        "actionFontColor": "#252423",
        "fontSize": 12,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5,
        "page": "Auto"
      },
      "visualHeader": {
        "show": true,
        "background": "#ffffff",
        "border": "#ffffff",
        "transparency": 0,
        "foreground": "#333",
        "showVisualInformationButton": true,
        "showVisualWarningButton": true,
        "showVisualErrorButton": true,
        "showDrillRoleSelector": true,
        "showDrillUpButton": true,
        "showDrillToggleButton": true,
        "showDrillDownLevelButton": true,
        "showDrillDownExpandButton": true,
        "showPinButton": true,
        "showFocusModeButton": true,
        "showFilterRestatementButton": true,
        "showSeeDataLayoutToggleButton": true,
        "showOptionsMenu": true,
        "showTooltipButton": false
      },
      "visualHeaderTooltip": {
        "text": "",
        "titleFontColor": "#C8C8C8",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      }
    }
  },
  "PowerApps_PBI_CV_C29F1DCC_81F5_4973_94AD_0517D44CC06A": {
    "config": {
      "changed": false,
      "title": "PowerApps for Power BI",
      "navSection": "qa",
      "icon": "PowerApps_PBI",
      "image": "powerAppsforPowerBI.png"
    },
    "items": {
      "title": {
        "show": true,
        "text": "fdghdfgj",
        "titleWrap": true,
        "fontColor": "#252423",
        "background": "#FFFFFF",
        "alignment": "left",
        "fontSize": 14,
        "fontFamily": "Segoe UI"
      },
      "background": {
        "show": true,
        "color": "#252423",
        "transparency": 0
      },
      "lockAspect": {
        "show": false
      },
      "border": {
        "show": false,
        "color": "#252423",
        "radius": 0
      },
      "dropShadow": {
        "show": false,
        "color": "#252423",
        "position": "Outer",
        "preset": "BottomRight",
        "shadowSpread": 3,
        "shadowBlur": 10,
        "angle": 45,
        "shadowDistance": 10,
        "transparency": 70
      },
      "visualHeader": {
        "show": true,
        "background": "#ffffff",
        "border": "#ffffff",
        "transparency": 0,
        "foreground": "#333",
        "showVisualInformationButton": true,
        "showVisualWarningButton": true,
        "showVisualErrorButton": true,
        "showDrillRoleSelector": true,
        "showDrillUpButton": true,
        "showDrillToggleButton": true,
        "showDrillDownLevelButton": true,
        "showDrillDownExpandButton": true,
        "showPinButton": true,
        "showFocusModeButton": true,
        "showFilterRestatementButton": true,
        "showSeeDataLayoutToggleButton": true,
        "showOptionsMenu": true,
        "showTooltipButton": false
      },
      "visualHeaderTooltip": {
        "text": "",
        "titleFontColor": "#C8C8C8",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      }
    }
  }
}